import $ from 'jquery';
import React from 'react';

import {
  accordionInit,
  addScrollDownElementOnSectionIfFullscreen,
  breadcrumbColor,
  contentListItemColor,
  correctArticleHeight,
  fixFurtherContentHeadlineMargin,
  initModalRevealsForArticle,
  initTwoClickIframes,
  jobToolInit,
  searchInit,
  showDisclaimer
} from '../../articleHelper';
import ArticlePresenter from '../../articlePresenter';
import { backgroundVideosInit } from '../../backgroundVideosInit';
import { ArticleImage, loadLargeImage } from '../articleImage';
import Breadcrumb from '../breadcrumb';
import CallToAction from '../callToAction';
import FormRenderer from '../forms/formRenderer';
import VideoRenderer from '../videos/videoRenderer';
import WidgetRenderer from '../widgets/widgetRenderer';

import MultipleColumnsArticle from './multipleColumnsArticle';
import { QuirionContent } from './QuirionContent';

class DefaultArticle extends React.Component {
  constructor() {
    super();
    this.state = {
      article: ArticlePresenter.nullArticle(),
      widgets: []
    };
  }

  componentDidMount() {
    this.ajaxArticle();
  }

  componentDidUpdate() {
    const { article } = this.state;
    const { articleId } = this.props;

    fixFurtherContentHeadlineMargin();
    addScrollDownElementOnSectionIfFullscreen(article.fullscreenOnepager, articleId);
    correctArticleHeight(articleId);
  }

  ajaxArticle() {
    const methods = [
      'selected_layout',
      'title',
      'content',
      'background_color',
      'background_option_for_content',
      'breadcrumb',
      'context_info',
      'call_to_action',
      'image_links_mobil_oben_content',
      'image_alt_links_mobil_oben',
      'image_links_mobil_unten_content',
      'image_alt_links_mobil_unten',
      'image_rechts_mobil_oben_content',
      'image_alt_rechts_mobil_oben',
      'image_rechts_mobil_unten_content',
      'image_alt_rechts_mobil_unten',
      'image_volle_breite_background',
      'image_alt_volle_breite',
      'image_focus_hintergrund_mini',
      'image_focus_hintergrund_teaser',
      'image_focus_hintergrund_background',
      'video_hintergrund',
      'image_videovorschau_content',
      'image_alt_videovorschau',
      'vimeo_video',
      'youtube_video',
      'video_position',
      'widget_ids',
      'column_articles_ids',
      'fullscreen_onepager'
    ].join();

    $.ajax({
      url: `/api/v3/articles/${
        this.props.articleId
      }.json?methods=${methods}&${window.location.search.substring(1)}`,
      method: 'GET',
      success: (data) => {
        if (data !== undefined && data !== null) {
          this.setState({ article: ArticlePresenter.getArticle(data) }, () => {
            loadLargeImage(this);
            contentListItemColor();
            breadcrumbColor();
            showDisclaimer();
            backgroundVideosInit();
            jobToolInit();
            searchInit();
            VideoRenderer.renderVideoModal(this.state.article.vimeoVideo);
            VideoRenderer.renderVideoModal(this.state.article.youtubeVideo);
            WidgetRenderer.widgetsForObject(this.state.article, (widgets) => {
              // set `widgets`-state for article and trigger callback for correct calculation of
              // article heights, if an `articleId` is given per props
              this.setState({ widgets }, () => {
                this.props.articleId && correctArticleHeight(this.props.articleId);
                initModalRevealsForArticle(this.props.articleId);
                accordionInit();
                initTwoClickIframes();
              });
            });
          });
        }
      },
      error: (xhr, status, err) => console.error(this.props.articleId, status, err.toString())
    });
  }

  render() {
    const { article, widgets } = this.state;

    if (article.layout === ArticlePresenter.ARTICLE_LAYOUTS.QUIRION) {
      return (
        <QuirionContent
          article={article}
          widgets={widgets}
          WidgetRenderer={WidgetRenderer}
          FormRenderer={FormRenderer}
        />
      );
    }

    const videoBackground = () => {
      let videoDiv = null;

      if ({}.hasOwnProperty.call(article.videoBackgroundSrc, 'webm')) {
        videoDiv = (
          <div className="video-bg video-bg--fullscreen">
            <video autoPlay muted loop playsInline poster={article.videoBackgroundSrc.jpg}>
              <source src={article.videoBackgroundSrc.mp4} type="video/mp4" />
              <source src={article.videoBackgroundSrc.webm} type="video/webm" />
              <source src={article.videoBackgroundSrc.ogv} type="video/ogg" />
            </video>
          </div>
        );
      }
      return videoDiv;
    };

    let layoutClass = '';
    let layoutBreadcrumbHeadline = null;
    let layoutImageFullWidth = null;

    if (article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_ZENTRIERTE_SPALTE) {
      layoutClass = 'centered-layout';
    }

    if (
      article.layout !== ArticlePresenter.ARTICLE_LAYOUTS.NUR_RECHTE_SPALTE &&
      !!article.title.length
    ) {
      layoutBreadcrumbHeadline = (
        <div className={`row breadcrumb-headline ${layoutClass}`}>
          {!!article.breadcrumb.length && <Breadcrumb breadcrumb={article.breadcrumb} />}
          <h1 className="no-margin-top">{article.title}</h1>
        </div>
      );
    }

    if (article.imageFullWidthUrl) {
      layoutImageFullWidth = (
        <div className="row">
          <div className="col-1-of-1">
            <ArticleImage
              imageUrl={article.imageFullWidthUrl}
              imageAlt={article.imageFullWidthAlt}
            />
          </div>
        </div>
      );
    }

    return (
      <div
        className={`background ${article.fullscreenOnepager ? 'fullscreen' : ''}`}
        style={Object.assign({}, article.imageBackground, {
          backgroundColor: article.backgroundColor
        })}
      >
        {videoBackground()}
        <div className="container">
          <div className="row">
            <aside className="sidebar">&nbsp;</aside>

            <article className={`content ${article.backgroundOptionForContent}`}>
              {layoutBreadcrumbHeadline}
              {layoutImageFullWidth}

              <div className={`row ${layoutClass}`}>
                <MainContent article={article} widgets={widgets} />
                <FurtherContent article={article} widgets={widgets} />
              </div>
              <MultipleColumnsContent article={article} />
            </article>

            <aside className="spacebar">&nbsp;</aside>
          </div>
        </div>
      </div>
    );
  }
}

DefaultArticle.propTypes = {
  articleId: React.PropTypes.number
};

function MainContent({ article, widgets }) {
  let gridClass = 'col-1-of-2';
  let vimeoVideo = null;
  let youtubeVideo = null;

  if (article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_ZENTRIERTE_SPALTE) {
    // only one column for centered column layout
    gridClass = 'col-1-of-1';
  }

  if (
    article.videoPosition === 'left' ||
    article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_ZENTRIERTE_SPALTE
  ) {
    // render videos under main content if the video position is set to 'left' or if the
    // centered column layout is selected, because there is no further content fot that case
    vimeoVideo = VideoRenderer.renderVideoImage(
      article.vimeoVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
    youtubeVideo = VideoRenderer.renderVideoImage(
      article.youtubeVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
  }

  return (
    <div className={`${gridClass} main-content content-lg`}>
      <ArticleImage imageUrl={article.imageLeftTopUrl} imageAlt={article.imageLeftTopAlt} />
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageRightTopUrl} imageAlt={article.imageRightTopAlt} />
      </div>
      {WidgetRenderer.renderWidgets(widgets, 'before-main-content')}
      <div dangerouslySetInnerHTML={{ __html: article.mainContent }} />
      <div className="hidden-mobile">
        <CallToAction
          callToActionText={article.callToActionText}
          callToActionLink={article.callToActionLink}
        />
      </div>
      {vimeoVideo}
      {youtubeVideo}
      {WidgetRenderer.renderWidgets(widgets, 'main-content-before-form')}
      {FormRenderer.displayFor(article, 'main_content')}
      {FormRenderer.formInModal(article, 'modal_main_content')}
      {WidgetRenderer.renderWidgets(widgets, 'main-content')}
      <div className="hidden-desktop">
        <ArticleImage imageUrl={article.imageLeftBottomUrl} imageAlt={article.imageLeftBottomAlt} />
      </div>
    </div>
  );
}

MainContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

function FurtherContent({ article, widgets }) {
  if (article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_ZENTRIERTE_SPALTE) {
    return (
      <div className="col-1-of-1 further-content content-sm">
        <div dangerouslySetInnerHTML={{ __html: article.furtherContent }} />
        <div className="hidden-desktop">
          <CallToAction
            callToActionText={article.callToActionText}
            callToActionLink={article.callToActionLink}
          />
        </div>
        {WidgetRenderer.renderWidgets(widgets, 'further-content-before-form')}
        {FormRenderer.displayFor(article, 'further_content')}
        {FormRenderer.formInModal(article, 'modal')}
        {WidgetRenderer.renderWidgets(widgets, 'further-content')}
      </div>
    );
  }

  let layoutBreadcrumbHeadline = null;
  let vimeoVideo = null;
  let youtubeVideo = null;

  if (article.videoPosition === 'right') {
    // render videos in further content if the selected video position is 'right'
    vimeoVideo = VideoRenderer.renderVideoImage(
      article.vimeoVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );

    youtubeVideo = VideoRenderer.renderVideoImage(
      article.youtubeVideo,
      article.imageVideoUrl,
      article.imageVideoAlt
    );
  }

  if (article.layout === ArticlePresenter.ARTICLE_LAYOUTS.NUR_RECHTE_SPALTE) {
    layoutBreadcrumbHeadline = (
      <div className="breadcrumb-headline">
        {!!article.breadcrumb.length && <Breadcrumb breadcrumb={article.breadcrumb} />}
        <h1 className="no-margin-top">{article.title}</h1>
      </div>
    );
  }

  return (
    <div className="col-1-of-2 further-content content-sm">
      {layoutBreadcrumbHeadline}
      <div className="hidden-mobile">
        <ArticleImage imageUrl={article.imageRightTopUrl} imageAlt={article.imageRightTopAlt} />
      </div>
      <div className="hidden-mobile">
        <ArticleImage
          imageUrl={article.imageRightBottomUrl}
          imageAlt={article.imageRightBottomAlt}
        />
      </div>
      <div dangerouslySetInnerHTML={{ __html: article.furtherContent }} />
      <div className="hidden-desktop">
        <CallToAction
          callToActionText={article.callToActionText}
          callToActionLink={article.callToActionLink}
        />
      </div>
      {vimeoVideo}
      {youtubeVideo}
      {WidgetRenderer.renderWidgets(widgets, 'further-content-before-form')}
      {FormRenderer.displayFor(article, 'further_content')}
      {FormRenderer.formInModal(article, 'modal')}
      {WidgetRenderer.renderWidgets(widgets, 'further-content')}
      <div className="hidden-desktop">
        <ArticleImage
          imageUrl={article.imageRightBottomUrl}
          imageAlt={article.imageRightBottomAlt}
        />
      </div>
    </div>
  );
}

FurtherContent.propTypes = {
  article: React.PropTypes.object,
  widgets: React.PropTypes.array
};

function MultipleColumnsContent({ article }) {
  if (!article.multipleColumnsArticle.length) {
    return null;
  }

  return (
    <div className="multiple-column-articles">
      {article.multipleColumnsArticle.map((articleId) => (
        <MultipleColumnsArticle
          articleId={articleId}
          gridClass={`col-1-of-${Math.min(article.multipleColumnsArticle.length, 4)}`}
          key={articleId}
        />
      ))}
    </div>
  );
}

MultipleColumnsContent.propTypes = {
  article: React.PropTypes.object
};

export default DefaultArticle;



// WEBPACK FOOTER //
// ./components/articles/defaultArticle.js